/* sts-scroll.js: the page behind a pop-up, and a new page (prototype v6.2
   handoff §1.1-1.3). Site-wide, loaded before assets/sts-ui.js, which locks
   through it.

     STS.scroll.lock(key)     freeze the page behind a pop-up, sheet or menu.
     STS.scroll.unlock(key)   One shared counter: nested pop-ups each lock and
                              the page is live again after the LAST unlock.
                              `key` is optional; a keyed lock is held once
                              however often it is asked for.
     STS.scroll.locked()      true while anything holds the page
     STS.scroll.anchor(el)    the spot to give back (default: what was tapped)
     STS.scroll.restore()     give it back again, for a redraw that lands after
                              the pop-up has closed (a server answer)
     STS.scroll.place(el)     put a changed item (product row, shipment box,
                              Paused and cancelled row) about where the shopper
                              tapped, BEFORE its check mark and glow (§1.2);
                              called while a pop-up is still open, the close
                              then leaves the page where place() put it
     STS.scroll.now(fn)       run fn with html's smooth scrolling off (a jump)
     STS.scroll.top()         jump to the top (a new screen)

   Events on document: sts:scroll:lock, and sts:scroll:unlock {anchor} once the
   spot is back, before the next paint (the place for a glow to start from).

   §1.1 the lock is overflow:hidden on <html> (assets/sts-components.css), plus
   right padding for the scrollbar it took away, measured, so nothing shifts
   sideways. The page keeps its scroll position the whole time: nothing is
   stored and nothing is scrolled back on close. (The old lock fixed <body>,
   which scrolled the page to the top and back on every close; html{scroll-
   behavior:smooth} turned that into a glide down from the top.)

   Locks with no code in their owner, watched here:
     - any element with data-sts-scroll-lock while it is shown (not [hidden]
       and has a box); data-sts-scroll-lock="860" only at 860px and below
       (the routine widget's phone sheet)
     - the phone menu, html[data-sts-drawer=open] (assets/sts-chrome.js)
     - the phone filter sheet, .sts-fpanel--sheet (assets/sts-collection.js)
     - a modal <dialog> not opened through STS.ui (quick view, Buy anyway,
       the loyalty ledger); STS.ui.open locks for its own
     - the LlamaCart drawer (.lcu__drawer--active). The app sets its own
       overflow lock too; this adds the spot and the shared counter.

   §1.2 what was tapped is remembered with its ancestors' positions; on the
   last unlock the first of them still on the page goes back to the same
   height on screen, so a row that was redrawn falls back to its list, then
   its section, and content that grew or shrank above it moves nothing.

   §1.3 layout/theme.liquid switches html's smooth scrolling off inline before
   the first paint, so a restored position, a #fragment and the phone cart's
   way back (assets/sts-cart-fx.js) land as jumps; it comes back here after
   load. The deliberate deep links (#my-routine, #loyalty-milestones) keep
   their glide: they ask for 'smooth' themselves, after load. */
(function (w, d) {
  'use strict';
  var STS = w.STS = w.STS || {};
  if (STS.scroll) return;
  var root = d.documentElement;
  var raf = w.requestAnimationFrame ? w.requestAnimationFrame.bind(w) : function (f) { return setTimeout(f, 16); };

  function sy() { return w.pageYOffset || root.scrollTop || 0; }
  function emit(name, detail) {
    try { d.dispatchEvent(new CustomEvent(name, { detail: detail || {} })); } catch (e) { /* old engine */ }
  }

  /* A behaviour-less scrollTo defers to html's scroll-behavior, which
     theme-base.css sets to smooth for everyone; this makes it a jump. */
  function now(fn) {
    var s = root.style, was = s.scrollBehavior;
    s.scrollBehavior = 'auto';
    try { fn(); } finally { s.scrollBehavior = was; }
  }
  function to(y) {
    now(function () { w.scrollTo(w.pageXOffset || 0, Math.max(0, Math.round(y))); });
  }

  /* §1.3: back on once the page has loaded (see the header). */
  function smooth() { if (root.style.scrollBehavior === 'auto') root.style.scrollBehavior = ''; }
  function loaded() { setTimeout(smooth, 500); }
  if (d.readyState === 'complete') loaded(); else w.addEventListener('load', loaded);

  // ------------------------------------------------------------ the spot

  var tapped = null, pin = null, spot = null, placed = false;
  d.addEventListener('pointerdown', function (e) { tapped = e.target; }, true);
  d.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' || e.key === ' ') tapped = d.activeElement;
  }, true);

  /* Not a spot: anything that is itself a pop-up or pinned to the screen. */
  var AWAY = 'dialog,[role="dialog"],[aria-modal="true"],[data-sts-scroll-lock],.sts-overlay,' +
    '.sts-sheet-host,#lcu-llama-cart,[data-sts-header],.sts-chrome-drawer,[data-sts-bnav],footer';
  function away(el) {
    try { return !!el.closest(AWAY); } catch (e) { return true; }
  }
  function onPage(el) {
    if (!el || el.nodeType !== 1 || !el.isConnected || !el.getClientRects().length || away(el)) return false;
    for (var x = el, i = 0; x && x !== d.body && i < 12; x = x.parentElement, i++) {
      var p = w.getComputedStyle(x).position;
      if (p === 'fixed' || p === 'sticky') return false;
    }
    return true;
  }
  function headH() {
    try { if (STS.jump && STS.jump.offset) return STS.jump.offset(false); } catch (e) { /* fall through */ }
    return w.innerWidth > 860 ? 120 : 76;
  }
  /* The element and every ancestor, each with its top now. With nothing
     tapped (a pop-up that opened by itself), the first section still on
     screen under the header; with none, the scroll position as it was. */
  function mark(el) {
    if (!onPage(el)) {
      el = null;
      var hd = headH(), list = d.querySelectorAll('main section, main h2, main .shopify-section');
      for (var i = 0; i < list.length && !el; i++) {
        var r = list[i].getBoundingClientRect();
        if (r.height && r.bottom > hd + 20 && !away(list[i])) el = list[i];
      }
    }
    var chain = [];
    for (var x = el; x && x !== d.body && x !== root; x = x.parentElement) {
      chain.push({ el: x, top: x.getBoundingClientRect().top });
    }
    return { chain: chain, y: sy(), tap: chain.length ? chain[0].top : null };
  }

  function restore(A) {
    A = A || spot;
    if (!A) return;
    var hit = null;
    for (var i = 0; i < A.chain.length && !hit; i++) {
      var c = A.chain[i];
      if (c.el.isConnected && c.el.getClientRects().length) hit = c;
    }
    var y = sy();
    var want = hit ? y + hit.el.getBoundingClientRect().top - hit.top : A.y;
    if (Math.abs(want - y) > 1) to(want);
  }

  /* §1.2, the prototype's restoreAnchor: centred on where the tap was, below
     the pinned header and clear of the bottom of the screen. */
  function place(el) {
    if (!el || !el.isConnected) return false;
    var r = el.getBoundingClientRect(), hd = headH();
    var tap = spot && spot.tap != null ? spot.tap : hd + 40;
    var want = Math.max(hd + 16, Math.min(tap - r.height / 2, w.innerHeight - r.height - 90));
    placed = true;
    to(sy() + r.top - want);
    return true;
  }

  function anchor(el) {
    pin = el || null;
    if (n && el) { spot = mark(el); pin = null; }
  }

  // ------------------------------------------------------------ the lock

  var held = {}, n = 0;

  function engage() {
    placed = false;
    spot = mark(pin || tapped);
    pin = null;
    var before = root.clientWidth;
    root.classList.add('sts-locked');
    /* What the lock actually took away: 0 with overlay scrollbars, with
       LlamaCart's own lock already on, or where a page keeps the gutter
       (assets/sts-liquid-quiz.css). */
    var sb = root.clientWidth - before;
    if (sb > 0) root.style.setProperty('--sts-sbw', sb + 'px');
    emit('sts:scroll:lock');
  }

  function release() {
    root.classList.remove('sts-locked');
    root.style.removeProperty('--sts-sbw');
    var A = spot;
    if (!placed) restore(A);
    var y = sy();
    emit('sts:scroll:unlock', { anchor: A });
    /* A redraw in the same task as the close lands after this: once more
       before the paint, unless something has moved the page since (a
       pop-up's own landing, a glow's scroll, place()). */
    raf(function () {
      if (!n && !placed && spot === A && Math.abs(sy() - y) < 1) restore(A);
    });
  }

  function lock(k) {
    if (k) { if (held[k]) return; held[k] = 1; }
    if (n++ === 0) engage();
  }
  function unlock(k) {
    if (k) { if (!held[k]) return; delete held[k]; }
    if (!n) return;
    if (--n === 0) release();
  }

  // ------------------------------------------------------------ watched

  var WATCH = 'html[data-sts-drawer="open"],.sts-fpanel--sheet:not([hidden]),.lcu__drawer--active';

  function modal() {
    var list = d.querySelectorAll('dialog[open]');
    for (var i = 0; i < list.length; i++) {
      var g = list[i], m = false;
      if (g.__sts) continue;   /* STS.ui.open holds its own lock */
      try { m = g.matches(':modal'); } catch (e) { /* no :modal */ }
      if (m || g.getAttribute('aria-modal') === 'true') return true;
    }
    return false;
  }
  function shown(el) {
    if (el.hidden || !el.getClientRects().length) return false;
    var at = +el.getAttribute('data-sts-scroll-lock');
    return !(at > 0 && w.innerWidth > at);
  }
  function check() {
    var want = false;
    try { want = !!d.querySelector(WATCH); } catch (e) { /* keep false */ }
    if (!want) want = modal();
    if (!want) {
      var list = d.querySelectorAll('[data-sts-scroll-lock]');
      for (var i = 0; i < list.length && !want; i++) want = shown(list[i]);
    }
    if (want) lock('watch'); else unlock('watch');
  }

  /* The drawer is a Preact app mounted at runtime; its class flips on its
     own renders, so it is watched once it exists, and looked for again after
     each of its toggle events (sent on open, on close and after every add). */
  var lcu = null;
  function lcuFind() {
    var el = d.getElementById('lcu-llama-cart');
    if (el && el !== lcu && w.MutationObserver) {
      lcu = el;
      new MutationObserver(check).observe(el, { attributes: true, attributeFilter: ['class'], subtree: true });
    }
    check();
  }

  if (w.MutationObserver) {
    new MutationObserver(check).observe(root, {
      attributes: true, subtree: true,
      attributeFilter: ['open', 'hidden', 'data-sts-drawer', 'data-sts-scroll-lock']
    });
  }
  d.addEventListener('lcu:cart:toggle', function () {
    [60, 400, 1000].forEach(function (t) { setTimeout(lcuFind, t); });
  });
  var rq = 0;
  w.addEventListener('resize', function () {
    if (!rq) rq = raf(function () { rq = 0; check(); });
  });
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', lcuFind); else lcuFind();
  w.addEventListener('load', lcuFind);

  STS.scroll = {
    lock: lock, unlock: unlock, locked: function () { return n > 0; },
    anchor: anchor, restore: function () { restore(spot); }, place: place,
    now: now, top: function () { to(0); }
  };
}(window, document));
